import { Create, SimpleForm } from 'react-admin';
import { NewsForm } from './NewsForm.jsx';

export const NewsCreate = () => (
  <Create redirect="list">
    <SimpleForm><NewsForm isCreate /></SimpleForm>
  </Create>
);
